module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_6.9cb11646.png";